import tokens from './tokens'

const supportPair = {
  token: [tokens.usdt.symbol],
  lp: [],
}

export default supportPair
